import React, { memo } from 'react';

import { defaultSize, sizePropsTypes } from './icons.constants';

const ListIcon = ({ size = defaultSize, ...props }) => (
  <svg
    fill="none"
    height={size}
    viewBox="0 0 24 24"
    width={size}
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      clipRule="evenodd"
      d="M2 5C2 4.44772 2.44772 4 3 4H3.04688C3.59916 4 4.04688 4.44772 4.04688 5C4.04688 5.55228 3.59916 6 3.04688 6H3C2.44772 6 2 5.55228 2 5ZM6 5C6 4.44772 6.44772 4 7 4H21C21.5523 4 22 4.44772 22 5C22 5.55228 21.5523 6 21 6H7C6.44772 6 6 5.55228 6 5ZM2 12C2 11.4477 2.44772 11 3 11H3.04688C3.59916 11 4.04688 11.4477 4.04688 12C4.04688 12.5523 3.59916 13 3.04688 13H3C2.44772 13 2 12.5523 2 12ZM6 12C6 11.4477 6.44772 11 7 11H21C21.5523 11 22 11.4477 22 12C22 12.5523 21.5523 13 21 13H7C6.44772 13 6 12.5523 6 12ZM2 19C2 18.4477 2.44772 18 3 18H3.04688C3.59916 18 4.04688 18.4477 4.04688 19C4.04688 19.5523 3.59916 20 3.04688 20H3C2.44772 20 2 19.5523 2 19ZM6 19C6 18.4477 6.44772 18 7 18H21C21.5523 18 22 18.4477 22 19C22 19.5523 21.5523 20 21 20H7C6.44772 20 6 19.5523 6 19Z"
      fill="currentColor"
      fillRule="evenodd"
    />
  </svg>
);

ListIcon.propTypes = {
  ...sizePropsTypes,
};

export default memo(ListIcon);
